module.exports = {
      id: "icon-timer-usage",
      viewBox: "0 0 15.177 16",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-timer",
      toString: function () {
        return this.url;
      }
    }